import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
// Uses the free public Abacus counter API (https://abacus.jasoncameron.dev)
// to track total visits across all users. The first request creates the counter.
const NAMESPACE = 'danceforfans-com';
const KEY = 'site-visits';
export function VisitCounter() {
  const {
    t
  } = useLanguage();
  const [count, setCount] = useState<number | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    // Avoid double-counting in dev/StrictMode for the same tab session
    const sessionKey = 'dff-visit-counted';
    const alreadyCounted = sessionStorage.getItem(sessionKey);
    const url = alreadyCounted ? `https://abacus.jasoncameron.dev/get/${NAMESPACE}/${KEY}` : `https://abacus.jasoncameron.dev/hit/${NAMESPACE}/${KEY}`;
    fetch(url).then(r => {
      if (!r.ok) throw new Error('counter request failed');
      return r.json();
    }).then((data: {
      value?: number;
    }) => {
      if (typeof data.value === 'number') {
        setCount(data.value);
        sessionStorage.setItem(sessionKey, '1');
      } else {
        setError(true);
      }
    }).catch(() => setError(true));
  }, []);
  if (error) return null;
  return <div className="inline-flex items-center gap-2 px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-full text-xs text-zinc-400" data-id="element-154">
      <Eye className="w-3.5 h-3.5 text-magenta-500" data-id="element-155" />
      <span data-id="element-156">
        {count === null ? <span className="opacity-60" data-id="element-157">{t('visit.counting')}</span> : <>
            <span className="font-medium text-zinc-200 tabular-nums" data-id="element-158">
              {count.toLocaleString()}
            </span>
            <span className="ml-1.5 uppercase tracking-widest text-[10px] text-zinc-500" data-id="element-159">
              {t('visit.visits')}
            </span>
          </>}
      </span>
    </div>;
}